export default {
  consts: {},
  labels: {},
}
